export default "__VITE_ASSET__BHkiYjoU__"